import { createContext, useState, useContext } from 'react';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';

export interface SelectableStateItem {
  name: string;
  selectableItem: SelectableItem;
}

export interface SelectableStateHandler {
  items: SelectableStateItem[];
  updateItems?: (newItem: SelectableStateItem) => void;
}

const initialSelectableState = {
  items: [],
};

export const FormSelectableContext = createContext<SelectableStateHandler>(initialSelectableState);

export const useFormSelectableContext = () => useContext(FormSelectableContext);

export const FormSelectableStateProvider = ({ children }) => {
  const [items, setItems] = useState<SelectableStateItem[]>(initialSelectableState.items);

  const updateItems = (newItem: SelectableStateItem) => {
    setItems([Object.assign(items, newItem)]);
  };

  return (
    <FormSelectableContext.Provider
      value={{
        items,
        updateItems,
      }}
    >
      {children}
    </FormSelectableContext.Provider>
  );
};
